/**
 * Redirects legacy Jarvis frontend routes to Jarvis 2.0.
 * Used so email links sent before migration still reach the new app.
 */

const REDIRECTABLE_PATHS = new Set([
  '/assign-contact',
  '/select-contact',
  '/exclude-domain',
  '/subscribe',
  '/unsubscribe',
  '/subscribe-success',
]);

export function getJarvis2Host(): string | null {
  const host = process.env.REACT_APP_JARVIS2_HOST?.trim();
  if (!host) return null;
  return host.startsWith('http')
    ? host.replace(/\/$/, '')
    : `https://${host.replace(/\/$/, '')}`;
}

export function getJarvis2RedirectUrl(
  pathname: string,
  search: string
): string | null {
  const jarvis2Host = getJarvis2Host();
  if (!jarvis2Host) return null;

  const params = new URLSearchParams(search);

  // Google OAuth callback lands on legacy root — forward to Jarvis 2.0 subscribe-success
  if (
    (pathname === '/' || pathname === '/subscribe-success') &&
    params.has('code')
  ) {
    return `${jarvis2Host}/subscribe-success${search}`;
  }

  if (pathname === '/' && !params.has('code')) {
    return `${jarvis2Host}/assign-contact${search}`;
  }

  if (REDIRECTABLE_PATHS.has(pathname)) {
    return `${jarvis2Host}${pathname}${search}`;
  }

  return null;
}

export function redirectToJarvis2IfNeeded(): boolean {
  const target = getJarvis2RedirectUrl(
    window.location.pathname,
    window.location.search
  );
  if (!target) return false;
  window.location.replace(target);
  return true;
}
